import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { getEmail } from '@domains/user/store/slices/user-slice/user-slice';
import { hasLaunchAuth } from '../launch.utils';

interface AuthGuard {
  ready: boolean;
  email: string | undefined;
}

export const useAuthGuard = (): AuthGuard => {
  const navigate = useNavigate();
  const email    = useSelector(getEmail);

  // Se requiere TANTO email en Redux como launch_token en localStorage.
  // Así se garantiza que el usuario pasó por /launch-login y que Redux
  // está completamente hidratado (roles, países, perfil).
  const isAuthenticated = !!email && hasLaunchAuth();

  const [ready, setReady] = useState(isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) {
      setReady(false);
      navigate('/launch-login', { replace: true });
      return;
    }
    setReady(true);
  }, [navigate, isAuthenticated]);

  return { ready, email };
};
